import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useContext } from "react";
import { LTCPContext } from "LTCP Module/LTCPContext";
import CloseIcon from "@mui/icons-material/Close";

function AlertWidget({ children }) {
  const { alertWidget, setAlertWidget } = useContext(LTCPContext);
  const { open, onClose, success, message } = alertWidget;

  return (
    <>
      {children}
      <Dialog
        open={open}
        onClose={() => {
          setAlertWidget({
            open: false,
            message: null,
            onClose: null,
            success,
          });
          onClose && onClose();
        }}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            background: success
              ? "linear-gradient(to bottom, #ecffec, #fff)"
              : "linear-gradient(to bottom, #ffd5d5, #fff)",
            color: "#000",
          },
        }}
      >
        <DialogTitle
          sx={{
            color: "#000",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {success ? "Success" : "Failed"}
          <IconButton
            onClick={() => {
              setAlertWidget({
                open: false,
                message: null,
                onClose: null,
                success,
              });
              onClose && onClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Stack gap={2} direction="row">
            {success ? (
              <Box
                sx={{
                  mt: 2,
                  width: 48,
                  minWidth: 48,
                  maxWidth: 48,
                  height: 48,
                  minHeight: 48,
                  maxHeight: 48,
                  background: "#fff",
                  borderRadius: 24,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#0f0a",
                  boxShadow: "0px 4px 12px 8px #0001",
                }}
              >
                <CheckCircleIcon />
              </Box>
            ) : (
              <Box
                sx={{
                  mt: 2,
                  width: 48,
                  minWidth: 48,
                  maxWidth: 48,
                  height: 48,
                  minHeight: 48,
                  maxHeight: 48,
                  background: "#fff",
                  borderRadius: 24,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#f00a",
                  boxShadow: "0px 4px 12px 8px #0001",
                }}
              >
                <WarningAmberIcon />
              </Box>
            )}
            <Stack gap={1}>
              <Typography color="#000">
                <b>
                  {success
                    ? "This is a success message"
                    : "This is an error message"}
                </b>
              </Typography>
              <Typography color="#000">
                {success &&
                  (message ? message : "Operation done successfully!")}
                {!success &&
                  (message
                    ? message
                    : "Something went wrong! Please refresh the page and try agian. If the error persist contact administrator.")}
              </Typography>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default AlertWidget;
